import { StatisticUnit } from '../../../enums/assetStatistic';

export const ASSET_LIST_EMPTY_COPY = {
  NO_ASSETS: 'No assets configured yet.',
  NO_RESULTS: 'No assets match the configured list.',
  NO_MATCHES: 'No assets match your search.',
  NO_STATISTIC_MATCHES: 'No assets match the selected statistic.',
  LOAD_ERROR: 'Unable to load assets. Please try again.',
};

export const SEARCH_DEBOUNCE_MS = 300;

// Must match .assetListRow's height (2.75rem); collapsed rows are never measured.
export const ASSET_ROW_HEIGHT_REM = 2.75;

export const STATISTIC_UNIT_LABELS: Record<StatisticUnit, string> = {
  [StatisticUnit.KM]: 'km',
  [StatisticUnit.M]: 'm',
  [StatisticUnit.MI]: 'mi',
  [StatisticUnit.KM2]: 'km²',
  [StatisticUnit.HA]: 'ha',
  [StatisticUnit.ACRES]: 'ac',
};

export const STATISTIC_VALUE_MAX_DECIMALS = 2;

export const NEW_LAYER_NOTICE = 'New layer(s) available to add to the asset list';

// Orange (with alpha) for the assets an active statistic counts and the selected asset; matches $ces-orange.
export const ASSET_HIGHLIGHT_COLOR = '#F37327B3';
